"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var connected_react_router_1 = require("connected-react-router");
var sok_ui_1 = require("@caddigital/sok-ui");
var ProjectSelector_1 = require("components/ProjectSelector");
var Types = require("types");
var ProjectActions = require("@caddigital/sok-reducers/lib/actions/projects");
var BriefcaseActions = require("@caddigital/sok-reducers/lib/actions/briefcase/list");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var Icon_1 = require("components/Icon");
var constants_1 = require("utils/constants");
var search_1 = require("utils/search");
var mapStateToProps = function (state, ownProps) {
    return {
        searchString: ownProps.currentProject
            ? state.briefcase.projectList.searchString
            : state.briefcase.list.searchString
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetchProjects: function (params) {
        return dispatch(ProjectActions.fetchProjects(params));
    },
    setSeachString: function (searchString, project) {
        return dispatch(BriefcaseActions.setSearchString(searchString, project ? project.id : undefined));
    },
    navigateToProject: function (lang, project) {
        dispatch((0, connected_react_router_1.push)("/".concat(lang, "/projects/").concat(project.id, "/briefcases")));
    }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('tempValue', 'setTempValue', null), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.fetchProjects({
            limit: 6,
            offset: 0,
            orderBy: 'visitedAt',
            order: 'desc'
        });
    }
}), recompose_1.pure);
var clearSearchCross = function (props) {
    return (React.createElement("span", { className: 'file-list-search-box-right' }, props.searchString !== '' && (React.createElement(Icon_1.Icon, { onClick: function () { return props.setSeachString('', props.currentProject); }, className: "fa-times" }))));
};
var timeout = null;
exports.SearchBar = enhance(function (props) { return (React.createElement(sok_ui_1.Grid.Row, { className: 'sok-search-bar-content' },
    React.createElement(sok_ui_1.Grid.Column, { extraSmall: 12 },
        props.currentProject && (React.createElement(ProjectSelector_1.ProjectSelector, { navigateToProject: props.navigateToProject })),
        React.createElement("div", { className: 'search-area' },
            React.createElement(sok_ui_1.TextInput, { value: props.tempValue === null ? props.searchString : props.tempValue, placeholder: (0, translation_1.getLocalization)('briefcaseListView/search/placeholder'), onChange: function (e) {
                    var value = e.target.value;
                    props.setTempValue(value);
                    if (timeout) {
                        clearTimeout(timeout);
                    }
                    timeout = setTimeout(function () {
                        props.setSeachString(value, props.currentProject);
                        props.updateUrl(props.pathname +
                            (0, search_1.getQueryParams)(__assign(__assign({}, props.queryParams), { search: value })));
                        props.setTempValue(null);
                    }, constants_1.SEARCH_TIMEOUT);
                }, icon: React.createElement(Icon_1.Icon, { key: "icon", className: 'fa-search' }), iconRight: clearSearchCross(props) }))))); });
